import * as React from 'react';
import { useForm as useReactHookForm, } from 'react-hook-form';
import qs from 'query-string';
export const validateNotWhitespaceOnly = (value, error) => typeof value === 'string' ? value.trim().length > 0 || error : true;
export function useForm(params) {
    const refContainer = React.useRef(null);
    const useReactHookFormReturn = useReactHookForm({
        defaultValues: params.defaultValues,
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        shouldUseNativeValidation: false,
    });
    const { handleSubmit } = useReactHookFormReturn;
    const [status, setStatus] = React.useState('initial');
    const [confirmationMessage, setConfirmationMessage] = React.useState('');
    const [serverErrors, setServerErrors] = React.useState([]);
    const onSubmit = async (formData, event) => {
        let res;
        if (params.mode === 'querystring') {
            window.location.href = `${params.endpoint}${params.endpoint.includes('?') ? '&' : '?'}${qs.stringify({
                ...formData,
            })}`;
            return;
        }
        else if (params.mode === 'multipart') {
            const formData = new FormData(event?.target);
            // We have to create the FormData instance before changing status
            // as disabled fields/fieldsets are not included otherwise.
            setStatus('pending');
            res = await fetch(params.endpoint, {
                body: formData,
                method: 'POST',
            });
        }
        else {
            setStatus('pending');
            res = await fetch(params.endpoint, {
                body: JSON.stringify(formData),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        }
        // If we're showing an error message then change to error.
        if (!res.ok) {
            setStatus('error');
            setServerErrors([`Something went wrong.`]);
            refContainer.current?.scrollIntoView({ behavior: 'auto', block: 'start' });
            return;
        }
        const resData = (await res.json());
        // If we're showing an error message then change to error.
        if (resData.errors?.length) {
            setStatus('error');
            setServerErrors(resData.errors);
            refContainer.current?.scrollIntoView({ behavior: 'auto', block: 'start' });
            return;
        }
        // At this stage we consider the submission successful so we
        // can trigger the optional callback.
        if (params.postSubmitCallback) {
            await params.postSubmitCallback();
        }
        // If we're showing a message then change to fulfilled.
        if (resData.message) {
            setStatus('fulfilled');
            setConfirmationMessage(resData.message);
            refContainer.current?.scrollIntoView({ behavior: 'auto', block: 'start' });
            return;
        }
        // If we're redirecting leave status pending.
        if (resData.redirect) {
            window.location.href = resData.redirect;
            return;
        }
    };
    return {
        confirmationMessage,
        refContainer,
        serverErrors,
        status,
        onSubmit: handleSubmit(onSubmit),
        useReactHookFormReturn,
    };
}
